import { render, staticRenderFns } from "./HistoricalSection.vue?vue&type=template&id=7f6bbcde&scoped=true&"
import script from "./HistoricalSection.vue?vue&type=script&lang=ts&"
export * from "./HistoricalSection.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricalSection.vue?vue&type=style&index=0&id=7f6bbcde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6bbcde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
